import { useState } from 'react';

const usePendingFetcherQueue = <T extends { fetcherKey?: string }>(): {
    lastFetcher: T;
    addToFetcherQueue: (item: T) => void;
    clearFetcherQueue: () => void;
} => {
    const [pendingFetcherQueue, setPendingFetcherQueue] = useState<T[]>([]);

    const addToFetcherQueue = (item: T) => {
        if (item.fetcherKey) {
            if (
                !pendingFetcherQueue.find(
                    (f) => f.fetcherKey === item.fetcherKey
                )
            ) {
                setPendingFetcherQueue([...pendingFetcherQueue, item]);
            }
        }
    };

    const clearFetcherQueue = () => {
        if (pendingFetcherQueue.length > 0) {
            setPendingFetcherQueue([]);
        }
    };

    return {
        lastFetcher: pendingFetcherQueue[pendingFetcherQueue.length - 1]!,
        addToFetcherQueue,
        clearFetcherQueue,
    };
};

export default usePendingFetcherQueue;
